/** Governed category options (legacy API values + operator labels). */
export const CATALOG_CATEGORY_OPTIONS = [
  { value: 'HEMATOLOGY', label: 'Haematology' },
  { value: 'BIOCHEMISTRY', label: 'Biochemistry' },
  { value: 'MICROBIOLOGY', label: 'Microbiology' },
  { value: 'SEROLOGY', label: 'Serology' },
  { value: 'IMMUNOLOGY', label: 'Immunology' },
  { value: 'HISTOPATHOLOGY', label: 'Histopathology' },
  { value: 'URINE_EXAMINATION', label: 'Urine Examination' },
  { value: 'CLINICAL_PATHOLOGY', label: 'Clinical Pathology' },
  { value: 'GENERAL', label: 'General' },
] as const

/** Governed specimen options (pilot — maps to enterprise specimen_type). */
export const CATALOG_SPECIMEN_OPTIONS = [
  { value: 'EDTA whole blood', label: 'EDTA whole blood' },
  { value: 'Serum', label: 'Serum' },
  { value: 'Random urine', label: 'Random urine' },
  { value: 'Stool', label: 'Stool' },
  { value: 'Sputum', label: 'Sputum' },
  { value: 'Semen', label: 'Semen' },
  { value: 'Body fluid', label: 'Body fluid' },
] as const

export const VALID_CATEGORIES = new Set(CATALOG_CATEGORY_OPTIONS.map((o) => o.value))

/** Returns validated category code or null — never silent-fallback to GENERAL. */
export function parseCategory(value: string): string | null {
  const v = value.trim().toUpperCase()
  if (!v) return null
  return VALID_CATEGORIES.has(v as (typeof CATALOG_CATEGORY_OPTIONS)[number]['value']) ? v : null
}

/** @deprecated Use parseCategory for create flows; import path may still normalize with explicit GENERAL. */
export function normalizeCategory(value: string): string {
  return parseCategory(value) ?? 'GENERAL'
}

export const CATEGORY_HELPER: Record<string, string> = {
  HEMATOLOGY: 'Blood counts, coagulation, peripheral smears',
  BIOCHEMISTRY: 'Glucose, lipids, liver, kidney and thyroid chemistries',
  URINE_EXAMINATION: 'Urine examination',
  CLINICAL_PATHOLOGY: 'Cardiac and other clinical pathology markers',
  MICROBIOLOGY: 'Cultures, stains, AFB',
  SEROLOGY: 'Immunoassays, infectious serology',
  IMMUNOLOGY: 'Immune markers & autoantibodies',
  HISTOPATHOLOGY: 'Tissue & cytology specimens',
  GENERAL: 'Urine, misc. — only when no department fits',
}

export const SPECIMEN_HELPER: Record<string, string> = {
  'EDTA whole blood': 'CBC, coagulation — lavender top',
  Serum: 'Chemistry, serology — gold/red top',
  'Random urine': 'Urinalysis, pregnancy strip',
  Stool: 'Ova, occult blood, reducing substances',
  Sputum: 'AFB, Gram stain, culture',
  Semen: 'Semen analysis',
  'Body fluid': 'Pleural, ascitic, CSF cultures',
}
